import { render, staticRenderFns } from "./dingdan_zitimendian.vue?vue&type=template&id=839e0f66&"
import script from "./dingdan_zitimendian.vue?vue&type=script&lang=js&"
export * from "./dingdan_zitimendian.vue?vue&type=script&lang=js&"
import style0 from "./dingdan_zitimendian.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports